import axios from "axios";
import type { AxiosInstance } from "axios";
const RAW_BASE = import.meta.env.VITE_API_BASE_URL || "http://localhost:3001";
const TRIMMED = RAW_BASE.replace(/\/+$/, "");
const BASE_URL = TRIMMED.endsWith("/api") ? TRIMMED : `${TRIMMED}/api`;

console.log("API BASE URL ->", BASE_URL);

const axiosInstance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    console.error(
      "[API ERROR]",
      err?.config?.method?.toUpperCase(),
      err?.config?.url,
      "→",
      err?.response?.status,
      err?.response?.data || err.message
    );
    return Promise.reject(err);
  }
);

export default axiosInstance;
